import React, { FunctionComponent } from 'react';

import styled, { useTheme } from 'styled-components';

import Typography from '@components/basics/typography';

interface RefIndicatorProps {
  className?: string;
  label?: React.ReactNode;
  circleOpacity?: number;
  marginBottom?: boolean;
  color?: 'grey' | 'accent' | 'warning' | string;
  customColor?: string;
  isBorder?: boolean;
}

const RefIndicator: FunctionComponent<RefIndicatorProps> = ({
  className,
  label,
  circleOpacity,
  marginBottom,
  color,
  customColor,
  isBorder,
}) => {
  const theme = useTheme();

  const getColor = (color: 'grey' | 'accent' | 'warning' | string) => {
    if (!color) {
      return theme.colors.blueColor;
    }
    switch (color) {
      case 'grey':
        return theme.colors.tertiary;
      case 'accent':
        return theme.colors.accent;
      case 'warning':
        return theme.colors.upload;
      default:
        return color;
    }
  };
  return (
    <Reference
      className={`${className || ''} ${marginBottom ? 'margin-bottom' : ''} ${
        !label ? 'no-margin' : ''
      }`}
    >
      <Circle
        className={`${!label ? 'no-margin' : ''} ${isBorder ? 'border' : ''}`}
        style={{
          opacity: circleOpacity ? circleOpacity : undefined,
          backgroundColor: isBorder
            ? 'transparent'
            : customColor
            ? customColor
            : color
            ? getColor(color)
            : undefined,
        }}
      />
      {label && (
        <Typography
          type="small"
          className={`text-label ${isBorder ? 'grey' : ''}`}
        >
          {label}
        </Typography>
      )}
    </Reference>
  );
};

export default styled(RefIndicator)`
  .text-label {
    &.grey {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;

const Reference = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4px;

  &.margin-bottom {
    margin-top: 0;
    margin-bottom: 4px;
  }

  &.no-margin {
    margin: 0;
  }
`;

const Circle = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.blueColor};
  margin-right: 4px;

  &.no-margin {
    margin: 0;
  }

  &.border {
    width: 5px;
    height: 5px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.tertiary};
  }
`;
